import { InheritedPermission, permissionAllowed, SystemShareOperate } from '@ews/react-data';
import { useL10n } from '@ews/react-localization-context';
import { useState } from 'react';
import { useDoubleConfirmDialog } from '../../../../../../../Dialog';
import { useMyPermissions } from '../../../../../../../Login/LoginProvider';
import { useModifySystemShareOperate, useSystem, useSystemShareOperate } from '../../../../../../../ReactData/system';
import SettingsCol from '../../../../../../../Settings/SettingsCol/SettingsCol';
import SettingsCheckbox from '../../../../../../../Settings/SettingsComponents/SettingsCeckbox/SettingsCeckbox';
import NumberRange from '../components/NumberRange';
import { Props } from './types';

const Operation: React.FC<Props> = ({ systemId, userId }) =>
{
    const myPermissions = useMyPermissions();
    const operation = useSystemShareOperate(systemId || "", userId!);
    const system = useSystem(systemId || "");
    const modify = useModifySystemShareOperate();
    const modifyData = async (data: SystemShareOperate) => await modify(systemId!, userId!, data);
    const [toggle, reset] = useState<boolean>(true);
    const dialog = useDoubleConfirmDialog();
    const { translate: t } = useL10n();

    const mayEditPermissions = permissionAllowed(myPermissions.grantSystemAccess || InheritedPermission.OFF) || false;

    const warn = async () =>
    {
        return await dialog({
            "title": t('[REACT_OVERRIDING_SYSTEM_DEFAULTS]'),
            "message": t('[REACT_OVERRIDE_ENABLEMENTS]'),
            areYouSureButtonTitle: t("COM_TEMPLATES_ARE_YOU_SURE"),
            "cancelButtonTitle": t('[SID_NO]'),
            "confirmButtonTitle": t('[SID_YES]')
        });
    };

    const allowedToEdit = permissionAllowed(myPermissions.createShare || 0);

    return <SettingsCol
    //    size='12' xl='12' md='12' lg='12' sm='12'
    >
        <SettingsCheckbox
            text={"COM_FACPMANAGEMENT_FACP_WLAN"}
            disabled={!mayEditPermissions}
            checked={operation.restrictOperationToWlanSSID || false}
            onChange={async (restrictOperationToWlanSSID: boolean) =>
            {
                if (await warn()) {
                    modifyData({ restrictOperationToWlanSSID } as SystemShareOperate);
                } else {
                    reset(!toggle);
                }
            }} />

        <SettingsCheckbox
            text={"COM_FACPMANAGEMENT_FACP_GPS"}
            disabled={!mayEditPermissions}
            checked={operation.restrictOperationToGPSArea || false}
            onChange={async (restrictOperationToGPSArea: boolean) =>
            {
                if (await warn()) {
                    modifyData({ restrictOperationToGPSArea } as SystemShareOperate);
                } else {
                    reset(!toggle);
                }
            }} />

        <SettingsCheckbox
            text={"COM_FACPMANAGEMENT_FACP_SINGLEUSERINAUTHORIZATION"}
            disabled={!mayEditPermissions}
            checked={operation.exclusiveAuthorization || false}
            onChange={async (exclusiveAuthorization: boolean) =>
            {
                if (await warn()) {
                    modifyData({ exclusiveAuthorization } as SystemShareOperate);
                } else {
                    reset(!toggle);
                }
            }} />

        <SettingsCheckbox
            text={"COM_FACPMANAGEMENT_FACP_USEIFFACPISINAUTHORIZATION"}
            disabled={!mayEditPermissions}
            checked={operation.restrictOperationToAuthorizedUsers || false}
            onChange={async (restrictOperationToAuthorizedUsers: boolean) =>
            {
                if (await warn()) {
                    modifyData({ restrictOperationToAuthorizedUsers } as SystemShareOperate);
                } else {
                    reset(!toggle);
                }
            }} />

        <SettingsCheckbox
            text={"COM_FACPMANAGEMENT_FACP_USEIFACCESSISENABLED"}
            disabled={!mayEditPermissions}
            checked={operation.restrictOperationToApprovedSession || false}
            onChange={async (restrictOperationToApprovedSession: boolean) =>
            {
                if (await warn()) {
                    modifyData({ restrictOperationToApprovedSession } as SystemShareOperate);
                } else {
                    reset(!toggle);
                }
            }} />

        <NumberRange
            disabled={!(allowedToEdit)}
            label='[SID_MNU_TAB_GROUPS]'
            from={operation.fromZone}
            to={operation.toZone}
            onChange={(fromZone, toZone) => modifyData({ fromZone, toZone } as SystemShareOperate)}
        />

        <NumberRange
            disabled={!(allowedToEdit)}
            label='[SID_MNU_TAB_CONTROLS]'
            from={operation.fromActuation}
            to={operation.toActuation}
            onChange={(fromActuation, toActuation) => modifyData({ fromActuation, toActuation } as SystemShareOperate)}
        />

        <NumberRange
            disabled={!(allowedToEdit)}
            label='[REACT_ALARMINGDEVICE]'
            from={operation.fromAlarmingDevice}
            to={operation.toAlarmingDevice}
            onChange={(fromAlarmingDevice, toAlarmingDevice) => modifyData({ fromAlarmingDevice, toAlarmingDevice } as SystemShareOperate)}
        />
        <NumberRange
            disabled={!(allowedToEdit)}
            label='[REACT_TRANSMISSIONDEVICE]'
            from={operation.fromTransmissionDevice}
            to={operation.toTransmissionDevice}
            onChange={(fromTransmissionDevice, toTransmissionDevice) => modifyData({ fromTransmissionDevice, toTransmissionDevice } as SystemShareOperate)}
        />
        {system.hasFloodingZone ? <>

            <NumberRange
                disabled={!allowedToEdit}
                label='COM_FACPMANAGEMENT_SHARE_FIELD_VIEW_FL_FZ_LABEL'
                from={operation.fromFloodingZone}
                to={operation.toFloodingZone}
                onChange={(fromFloodingZone, toFloodingZone) => modifyData({ fromFloodingZone, toFloodingZone } as SystemShareOperate)}
            />
        </> : <></>}

    </SettingsCol>;
};
export default Operation;
